var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 64 64",
    width: 64,
    height: 64,
    style: {
      enableBackground: "new 0 0 64 64"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0A0A0A;}\n\t.st1{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,49.6V14.4c0-0.5,0.1-1,0.3-1.4c0.2-0.5,0.5-0.9,0.8-1.2c0.4-0.4,0.8-0.6,1.2-0.8c0.5-0.2,0.9-0.3,1.4-0.3 h56.5c0.5,0,1,0.1,1.4,0.3c0.5,0.2,0.9,0.5,1.2,0.8c0.4,0.4,0.6,0.8,0.8,1.2c0.2,0.5,0.3,0.9,0.3,1.4v35.1c0,0.5-0.1,1-0.3,1.4 c-0.2,0.5-0.5,0.9-0.8,1.2c-0.4,0.4-0.8,0.6-1.2,0.8c-0.5,0.2-0.9,0.3-1.4,0.3H3.8c-0.5,0-1-0.1-1.4-0.3c-0.5-0.2-0.9-0.5-1.2-0.8 c-0.4-0.4-0.6-0.8-0.8-1.2C0.1,50.5,0,50.1,0,49.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M39.8,27.2c0.7,2.5,1.7,6.5,2.4,9c1,3.9,1.3,4.7,2.2,5.6c0.6,0.6,1.3,1,1.8,1c1,0,2.2-1,2.7-2.1 c0.3-0.8,4.8-17.4,4.8-17.8c0-0.1-0.9-0.2-1.9-0.1l-2,0.1L48,29.6c-1.1,4.3-1.8,6.5-1.9,6.1C45.8,35,42.7,23,42.7,22.9 c0-0.1-0.9-0.1-2-0.1h-2L39.8,27.2z M27,23.6c-0.6,0.8-0.7,1.2-0.7,9.3v8.4l0.8,0.8c0.7,0.8,0.9,0.8,5,0.8h4.2v-3.4l-3.2-0.1 L30,39.2v-4.7l2-0.1l1.9-0.1v-3.4h-4.1v-4.7h6.6v-3.5H32C27.7,22.7,27.6,22.7,27,23.6z M19.8,26.8c0.7,0.6,0.8,0.7,0.8,5.8 c0,4.9,0,5.2-0.7,5.9c-0.5,0.5-1.1,0.7-2.2,0.7l-1.5,0l-0.1-6.5L16,26.2h1.5C18.6,26.2,19.3,26.4,19.8,26.8L19.8,26.8z  M12.5,32.8v10h3.5c3.9,0,5.6-0.5,6.7-2c1.2-1.5,1.4-2.8,1.3-8.8c-0.1-5.3-0.2-5.7-0.8-6.8c-1.2-1.9-2.5-2.4-6.9-2.4h-3.8V32.8z"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevto);
export default __webpack_public_path__ + "static/media/devto.30cc16300608567af5ac3902a293fa13.svg";
export { ForwardRef as ReactComponent };